// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container styling for the page */
.container-adds-or-clips {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    margin-top: 150px;
    flex-wrap: wrap; /* Allows text to wrap and maintain centering on smaller screens */
}

/* General link styling */
.link {
    font-size: 69px; /* Large font size */
    font-weight: 800; /* Medium font weight */
    color: #000000; /* Black text */
    text-decoration: none; /* Remove underline */
    margin: 100px; /* Spacing between links */
    padding: 10px; /* Padding for space */
    transition: all 0.3s ease-in-out; /* Smooth hover transition */
    text-align: center; /* Center the text */
    white-space: nowrap; /* Prevent text from breaking into multiple lines */
}

/* Styling for the "video" part of the text */
.video-text {
    font-family: "EB Garamond", "EB Garamond Placeholder", serif;
    font-size: 35px;
    font-style: italic;
    margin-right: 10px;
    color: #393939;
    font-weight: 100;
}

/* Styling for "ADS" */
.adds-text {
    font-size: 42px;
    color: #000000;
    font-family: "CreatoDisplay", sans-serif;
    font-weight: 800;
    text-transform: uppercase;
}

/* Styling for "CLIPS" */
.clips-text {
    font-size: 42px;
    color: #000000;
    font-family: "CreatoDisplay", sans-serif;
    font-weight: 800;
    text-transform: uppercase;
}

/* Hover effect for links */
.link:hover {
    color: #000000; /* Black text on hover */
    transform: scale(1.1); /* Slight zoom effect */
}

/* Mobile version */
@media (max-width: 768px) {
    .container-adds-or-clips {
        flex-direction: column; /* Stack items vertically */
        align-items: center; /* Center items */
        margin-top: 80px; /* Adjust top margin for better spacing */
    }

    .link {
        font-size: 30px; /* Smaller font size for mobile */
        padding: 10px 20px; /* Adjust padding for mobile view */
        margin: 20px 0; /* Reduce margin between links */
        text-align: center; /* Ensure text stays centered */
    }

    .video-text {
        font-size: 25px; /* Smaller font for mobile */
        margin-right: 5px; /* Adjust spacing */
    }

    .adds-text, .clips-text {
        font-size: 32px; /* Adjust font size for mobile */
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/PreVideo.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe,EAAE,kEAAkE;AACvF;;AAEA,yBAAyB;AACzB;IACI,eAAe,EAAE,oBAAoB;IACrC,gBAAgB,EAAE,uBAAuB;IACzC,cAAc,EAAE,eAAe;IAC/B,qBAAqB,EAAE,qBAAqB;IAC5C,aAAa,EAAE,0BAA0B;IACzC,aAAa,EAAE,sBAAsB;IACrC,gCAAgC,EAAE,4BAA4B;IAC9D,kBAAkB,EAAE,oBAAoB;IACxC,mBAAmB,EAAE,mDAAmD;AAC5E;;AAEA,6CAA6C;AAC7C;IACI,4DAA4D;IAC5D,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,eAAe;IACf,cAAc;IACd,wCAAwC;IACxC,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,cAAc;IACd,wCAAwC;IACxC,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,cAAc,EAAE,wBAAwB;IACxC,qBAAqB,EAAE,uBAAuB;AAClD;;AAEA,mBAAmB;AACnB;IACI;QACI,sBAAsB,EAAE,2BAA2B;QACnD,mBAAmB,EAAE,iBAAiB;QACtC,gBAAgB,EAAE,yCAAyC;IAC/D;;IAEA;QACI,eAAe,EAAE,iCAAiC;QAClD,kBAAkB,EAAE,mCAAmC;QACvD,cAAc,EAAE,gCAAgC;QAChD,kBAAkB,EAAE,+BAA+B;IACvD;;IAEA;QACI,eAAe,EAAE,4BAA4B;QAC7C,iBAAiB,EAAE,mBAAmB;IAC1C;;IAEA;QACI,eAAe,EAAE,gCAAgC;IACrD;AACJ","sourcesContent":["/* Container styling for the page */\n.container-adds-or-clips {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n    margin-top: 150px;\n    flex-wrap: wrap; /* Allows text to wrap and maintain centering on smaller screens */\n}\n\n/* General link styling */\n.link {\n    font-size: 69px; /* Large font size */\n    font-weight: 800; /* Medium font weight */\n    color: #000000; /* Black text */\n    text-decoration: none; /* Remove underline */\n    margin: 100px; /* Spacing between links */\n    padding: 10px; /* Padding for space */\n    transition: all 0.3s ease-in-out; /* Smooth hover transition */\n    text-align: center; /* Center the text */\n    white-space: nowrap; /* Prevent text from breaking into multiple lines */\n}\n\n/* Styling for the \"video\" part of the text */\n.video-text {\n    font-family: \"EB Garamond\", \"EB Garamond Placeholder\", serif;\n    font-size: 35px;\n    font-style: italic;\n    margin-right: 10px;\n    color: #393939;\n    font-weight: 100;\n}\n\n/* Styling for \"ADS\" */\n.adds-text {\n    font-size: 42px;\n    color: #000000;\n    font-family: \"CreatoDisplay\", sans-serif;\n    font-weight: 800;\n    text-transform: uppercase;\n}\n\n/* Styling for \"CLIPS\" */\n.clips-text {\n    font-size: 42px;\n    color: #000000;\n    font-family: \"CreatoDisplay\", sans-serif;\n    font-weight: 800;\n    text-transform: uppercase;\n}\n\n/* Hover effect for links */\n.link:hover {\n    color: #000000; /* Black text on hover */\n    transform: scale(1.1); /* Slight zoom effect */\n}\n\n/* Mobile version */\n@media (max-width: 768px) {\n    .container-adds-or-clips {\n        flex-direction: column; /* Stack items vertically */\n        align-items: center; /* Center items */\n        margin-top: 80px; /* Adjust top margin for better spacing */\n    }\n\n    .link {\n        font-size: 30px; /* Smaller font size for mobile */\n        padding: 10px 20px; /* Adjust padding for mobile view */\n        margin: 20px 0; /* Reduce margin between links */\n        text-align: center; /* Ensure text stays centered */\n    }\n\n    .video-text {\n        font-size: 25px; /* Smaller font for mobile */\n        margin-right: 5px; /* Adjust spacing */\n    }\n\n    .adds-text, .clips-text {\n        font-size: 32px; /* Adjust font size for mobile */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
